import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Link } from 'react-router-dom';

var RowItem = /*#__PURE__*/function (_Component) {
  _inherits(RowItem, _Component);

  var _super = _createSuper(RowItem);

  function RowItem() {
    _classCallCheck(this, RowItem);

    return _super.apply(this, arguments);
  }

  _createClass(RowItem, [{
    key: "render",
    value: function render() {
      var props = _objectSpread({}, this.props);

      delete props.children;
      delete props.target;

      if (this.props.target != null) {
        return /*#__PURE__*/React.createElement(Link, _extends({
          className: "row",
          to: this.props.target
        }, props), this.props.children);
      }

      return /*#__PURE__*/React.createElement("div", _extends({
        className: "row"
      }, this.props), this.props.children);
    }
  }]);

  return RowItem;
}(Component);

export var RowCell = function RowCell(props) {
  var className = 'cell';

  if (props.grow) {
    className += ' grow';
  }

  if (props.shrink) {
    className += ' shrink';
  }

  var elementProps = _objectSpread({}, props);

  delete elementProps.grow;
  delete elementProps.shrink;
  delete elementProps.children;
  delete elementProps.title;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    title: props.title
  }, elementProps), props.children);
};
export default RowItem;